import { format, isToday, isYesterday } from "date-fns";
import { ptBR } from "date-fns/locale";

/**
 * Separador estilo WhatsApp: "HOJE" / "ONTEM" / "QUARTA-FEIRA, 23 DE ABRIL".
 * Pequena linha horizontal com label centralizado, separa msgs de dias
 * diferentes no scroll do chat.
 */
export default function DayDivider({ date }) {
  let label;
  try {
    if (isToday(date))         label = "HOJE";
    else if (isYesterday(date)) label = "ONTEM";
    else label = format(date, "EEEE, d 'de' MMMM", { locale: ptBR }).toUpperCase();
  } catch {
    return null;
  }
  return (
    <div className="flex items-center my-4 gap-3" data-testid="chat-day-divider">
      <div className="flex-1 h-px bg-white/5" />
      <span className="text-[10px] tracking-widest text-slate-500 font-medium">{label}</span>
      <div className="flex-1 h-px bg-white/5" />
    </div>
  );
}

/**
 * Helper compartilhado pelos consumidores (ChatPanel + NectarDashboard).
 * Compara dia local entre 2 timestamps (ms ou Date). False se algum vier
 * falsy ou se parsear lançar exceção.
 */
export function isSameDay(a, b) {
  if (!a || !b) return false;
  try {
    return new Date(a).toDateString() === new Date(b).toDateString();
  } catch {
    return false;
  }
}
